/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Enum representing the publication status of an ATS job mapping.
 * @export
 */
export const AtsJobMappingStatus = {
    Published: 'Published',
    Unpublished: 'Unpublished'
};
export function instanceOfAtsJobMappingStatus(value) {
    for (const key in AtsJobMappingStatus) {
        if (Object.prototype.hasOwnProperty.call(AtsJobMappingStatus, key)) {
            if (AtsJobMappingStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function AtsJobMappingStatusFromJSON(json) {
    return AtsJobMappingStatusFromJSONTyped(json, false);
}
export function AtsJobMappingStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function AtsJobMappingStatusToJSON(value) {
    return value;
}
export function AtsJobMappingStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
